import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  makeStyles,
} from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';
import { processTypesActions } from '../reducer';
import styles from '../styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(styles);

function ModalLoss({ open, onClose, selectedItems = [], processTypeList = [], setSelectedItems }) {
  const classes = useStyles();
  const [lossPercentage, setLossPercentage] = useState('');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleSubmit = () => {
    const processTypeIds = processTypeList.map((pt) => pt.id);

    dispatch(processTypesActions.updateLossPercentage(parseFloat(lossPercentage), processTypeIds));
    setSelectedItems(new Set());
    onClose();
    setLossPercentage('');
  };

  const handleCancel = () => {
    setLossPercentage('');
    onClose();
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    if (value === '' || (parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
      setLossPercentage(value);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 12,
        },
      }}>
      <DialogTitle className={classes.dialogTitle}>
        <Box className={classes.titleContent}>
          <Box className={classes.iconContainer}>
            <Typography variant="h6" style={{ color: 'white' }}>
              %
            </Typography>
          </Box>
          <Typography variant="h5" component="h2">
            {t('Change loss percentage title')}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Paper className={classes.infoBox} elevation={0}>
          <InfoIcon color="primary" />
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {t('You have selected {{count}} process types', {
              count: processTypeList.length,
            })}
          </Typography>
        </Paper>
        <Box className={classes.inputSection}>
          <Typography variant="body1" style={{ fontWeight: 500, marginBottom: 12 }}>
            {t('New loss percentage to apply:')}
          </Typography>
          <TextField
            type="number"
            value={lossPercentage}
            onChange={handleInputChange}
            placeholder="0"
            variant="outlined"
            fullWidth
            inputProps={{
              min: 0,
              max: 100,
              step: 0.1,
              style: { fontSize: 18 },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography variant="body1" color="textSecondary">
                    %
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <hr
          style={{
            border: 'none',
            borderTop: '1px solid #ccc',
            margin: '1.5rem 0',
          }}
        />
        {processTypeList.length > 0 && (
          <Box className={classes.processSection}>
            <Typography variant="body1" style={{ fontWeight: 500, marginBottom: 8 }}>
              {t('Selected processes:')}
            </Typography>
            <Box className={classes.chipContainer}>
              {processTypeList.slice(0, 8).map((processType) => (
                <Chip
                  key={processType.id}
                  label={processType.name}
                  variant="outlined"
                  size="small"
                  className={classes.chip}
                />
              ))}
              {processTypeList.length > 8 && (
                <Chip
                  label={t('+more_count more...', { count: processTypeList.length - 8 })}
                  variant="outlined"
                  size="small"
                  className={classes.chip}
                />
              )}
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        style={{ padding: '16px 24px', display: 'flex', justifyContent: 'space-between' }}>
        <Button
          onClick={handleCancel}
          color="primary"
          variant="outlined"
          style={{ marginRight: 8 }}>
          {t('CANCEL')}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!lossPercentage || processTypeList.length === 0}>
          {t('Apply changes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalLoss;
